// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep .erpDrawer .el-drawer__header {\n  height: 50px;\n  line-height: 50px;\n  padding-left: 24px;\n  box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
